import { render } from "./TopBrands.vue?vue&type=template&id=2b780f01&scoped=true"
import script from "./TopBrands.vue?vue&type=script&lang=js"
export * from "./TopBrands.vue?vue&type=script&lang=js"

import "./TopBrands.vue?vue&type=style&index=0&id=2b780f01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b780f01"],['__file',"src/components/TopBrands.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b780f01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b780f01', __exports__)) {
    api.reload('2b780f01', __exports__)
  }
  
  module.hot.accept("./TopBrands.vue?vue&type=template&id=2b780f01&scoped=true", () => {
    api.rerender('2b780f01', render)
  })

}


export default __exports__